import { PROFILE } from 'modules/layout/drawer/drawerItems';

const NO_REDIRECT_ROUTES = [PROFILE.route];

// eslint-disable-next-line import/prefer-default-export
export const isNoRedirectRoute = route => NO_REDIRECT_ROUTES.includes(route);

export const DEFAULT_ORG_ROUTE = 'currentSports';
